export const enClientPortalTaskListPagePages = {
    orders: {
        taskListPage: {
            allOrders: 'All orders',
            titleForAsset: 'Tasks for {{assetTitle}}',
            openTasks_one: '{{count}} open task',
            openTasks_other: '{{count}} open tasks',
            addTaskTooltip: 'Add task',
            dashboard: {
                open: 'Open',
                completed: 'Completed',
                noDeadline: 'No deadline',
                deleteTask: 'Delete task',
                deleteConfirm: 'Delete',
                deleteTitle: 'Do you really want to delete task "{{taskTitle}}"?',
                assigneeSearchPlaceholder: 'Search users',
            },
            create: {
                title: 'New task',
                orderOption: 'Order {{orderTitle}}',
                taskTitle: 'Title',
                dueDate: 'Due date',
                assignee: 'Assignee',
                description: 'Description',
                createMore: 'Create another task',
                create: 'Create',
                cancel: 'Cancel',
            },
        },
    },
}
